export default {
      id: "print-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.df848786.svg#print",
      toString: function () {
        return this.url;
      }
    }